import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BottlerInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the current URL using window.location.href
    const url = new URL(window.location.href);
    let bottlerValue = url.searchParams.get('bottler');

    if (bottlerValue) {
      // If 'bottler' is found in the URL, store it in localStorage for persistent use
      localStorage.setItem('bottler', bottlerValue);
    } else {
      // If 'bottler' is NOT in the URL, retrieve it from localStorage
      bottlerValue = localStorage.getItem('bottler');

      if (bottlerValue) {
        // If 'bottler' exists in localStorage, update the current URL to include it
        const updatedUrl = this.addQueryParamToUrl(window.location.href, 'bottler', bottlerValue);
        window.history.pushState(null, '', updatedUrl);
      }
    }

    // Modify the HTTP request to include the 'bottler' value as a header
    const modifiedReq = req.clone({
      headers: bottlerValue ? req.headers.set('bottler', bottlerValue) : req.headers,
    });

    return next.handle(modifiedReq);
  }

  //  function to dynamically add or update query parameters in the URL
  private addQueryParamToUrl(url: string, paramKey: string, paramValue: string): string {
    const urlObj = new URL(url);
    urlObj.searchParams.set(paramKey, paramValue);
    return urlObj.toString();
  }
}
